/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  const videoPlayBtns = document.querySelectorAll('.js-gr-embedded-video__play');
  if (videoPlayBtns) {
    videoPlayBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const wrapper = btn.closest('.gr-embedded-video');
        const iframe = wrapper.querySelector('.gr-embedded-video__iframe');
        wrapper.classList.add('gr-embedded-video_state_play')
        iframe.setAttribute('src', iframe.dataset.src);
      });
    });
  }
});